import React, { useState, useEffect } from 'react';
import shopify from "../../../../../js/shopify";
import hasher from "../../../../../js/alpine/stores/hasher";
import arcBridge from 'frontend/js/arcBridge';

declare global {
  interface Window {
    customerId?: string;
  }
}

interface Store {
  id: string;
  name: string;
  address_street_1?: string;
  address_street_2?: string;
  city?: string;
  state?: string;
  postcode?: string | number;
  country?: string;
  phone_number?: string;
  store_number?: string | number;
}

const AccountPreferredStore = () => {
  const [selectedStore, setSelectedStore] = useState<Store | null>(null);
  const [lastSavedStore, setLastSavedStore] = useState<Store | null>(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const savedPreferredStore = async (storeToSave?: Store) => {
    const store = storeToSave || selectedStore;
    if (!store) return;

    try {
      const res = await arcBridge.updateCustomerProfilePreferredStore({ "store_number": store.store_number });

      if (res?.success) {
        setSuccessMessage("Update successful!");
        setErrorMessage("");
        setLastSavedStore(store);
        localStorage.setItem("preferredStoreName", store.name);
      } else {
        throw new Error("Failed to update preferred store");
      }
    } catch (error) {
      setErrorMessage("Error updating information");
      setSuccessMessage("");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handlePreferredStoreUpdate = (e) => {
      setIsLoading(true);
      setSuccessMessage("");
      setErrorMessage("");
      setSelectedStore(e.detail);
      savedPreferredStore(e.detail);
    };

    const handlePreferredStoreChecked = (e) => {
      setSelectedStore(e.detail);
      setIsLoading(false);
    }

    window.addEventListener("preferredStoreUpdated", handlePreferredStoreUpdate);
    window.addEventListener("preferredStoreChecked", handlePreferredStoreChecked);

    return () => {
      window.removeEventListener("preferredStoreUpdated", handlePreferredStoreUpdate);
      window.removeEventListener("preferredStoreChecked", handlePreferredStoreChecked);
    };
  }, []);

  return (
    <>
      <section className="mt-8">
        <label className="text-[#54565A] b2 block mb-4">
          My preferred store
        </label>

        <div className="border border-[#A2A9AD] py-6 px-4 flex flex-col gap-4 justify-between lg:p-6 lg:flex-row lg:gap-0">
          <div>
            <span className="bc text-[#54565A] uppercase mb-4 block">
              Selected store
            </span>
            {isLoading ? (
              <div className='text-[#54565A] blabel'>Loading preferred store...</div>
            ) : selectedStore && typeof selectedStore === "object" && !Array.isArray(selectedStore) && !!selectedStore.name ? (
              <div className='flex flex-col space-y-[2px] text-black b2'>
                <p>{selectedStore.name}</p>
                <p>{selectedStore.address_street_1}</p>
                <p>{selectedStore.address_street_2}</p>
                <p>{selectedStore.city} {selectedStore.state}, {selectedStore.postcode}</p>
                <p>{selectedStore.country}</p>
                <p>{selectedStore.phone_number}</p>
              </div>
            ) : (
              <div className='text-[#54565A] b2'>No store selected.</div>
            )}
          </div>
          <button
            className="!px-5 !py-4 button btn-outline w-max"
            onClick={() => {
              const event = new CustomEvent("openStoreModalFromAccount");
              window.dispatchEvent(event);
            }}
          >
            <i className='hidden text-2xl text-black icon icon-location-wide lg:block'></i> Change store
          </button>
        </div>
      </section>

      {successMessage && <div className="!mt-0 form-success">{successMessage}</div>}
      {errorMessage && <div className="!mt-0 errors">{errorMessage}</div>}
    </>
  );
};

export default AccountPreferredStore;